export default __webpack_public_path__ + "static/media/13_photo.034380bc.jpeg";